export default "__VITE_ASSET__BjAWCqgK__"